import Reveal from "./Reveal";

const FIRST_PRIZE =
  "acesso anual à escape club + camiseta + 1 mês de mentoria de inglês personalizada";

const OTHER_PRIZES = [
  {
    place: "2º",
    prize:
      "acesso semestral + camiseta + consulta nutricional + 1 mês de mentoria de inglês personalizada",
  },
  {
    place: "3º",
    prize:
      "acesso semestral + 1 mês de acompanhamento Animus + 1 mês de mentoria de inglês personalizada",
  },
  {
    place: "4º",
    prize:
      "acesso trimestral + voucher R$100 Growth Suplementos + 1 mês de mentoria de inglês personalizada",
  },
  {
    place: "5º",
    prize:
      "acesso mensal + voucher R$100 Growth Suplementos + 1 mês de mentoria de inglês personalizada",
  },
];

const Prizes = () => (
  <section className="px-6 py-20 sm:py-28">
    <div className="mx-auto max-w-3xl">
      <Reveal className="text-center">
        <h2 className="text-3xl font-extrabold leading-tight tracking-[-0.03em] sm:text-5xl">
          top 5 mais consistentes levam prêmio real.
        </h2>
        <p className="mx-auto mt-4 max-w-lg text-base leading-relaxed text-black/60 sm:text-lg">
          quem não falha o check-in sobe no ranking. consistência conta mais
          que perfeição.
        </p>
      </Reveal>

      {/* 1º lugar em destaque */}
      <Reveal delay={100} className="mt-12">
        <div className="rounded-2xl border-2 border-black bg-black p-8 text-white shadow-[0_20px_50px_rgba(0,0,0,0.25)] sm:p-10">
          <span className="e21-serif text-4xl sm:text-5xl">1º</span>
          <p className="mt-3 text-lg font-bold leading-snug tracking-[-0.02em] sm:text-xl">
            {FIRST_PRIZE}
          </p>
        </div>
      </Reveal>

      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {OTHER_PRIZES.map((item, i) => (
          <Reveal key={item.place} delay={160 + i * 80}>
            <div className="h-full rounded-2xl border border-black/10 p-6 transition-all duration-200 hover:scale-[1.02] hover:shadow-lg">
              <span className="text-2xl font-extrabold tracking-[-0.03em] text-black/30">
                {item.place}
              </span>
              <p className="mt-2 text-sm font-medium leading-snug sm:text-base">
                {item.prize}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* bônus comum a todo o top 5 */}
      <Reveal delay={480} className="mt-4">
        <div className="rounded-2xl border border-black/10 bg-neutral-50 px-6 py-5 text-center">
          <p className="text-sm font-medium sm:text-base">
            todos do top 5 →{" "}
            <span className="font-bold">
              1 mês de mentoria de inglês personalizada
            </span>
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Prizes;
